import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";
import store from "../store";

export const listarProovedoresTerrestres = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/listarProveedoresTerrestres`,
    {
      data
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
export const getProvidersExtraCost = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);

export const getProvidersExtraCostInit = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost/init`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);


export const addProvidersExtraCost = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);

export const findProvidersExtraCost = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost/find`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);


export const updateProvidersExtraCost = payload =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);

export const deleteProvidersExtraCost = payload =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        data: payload
      })
    .then(({ data }) => data);

export const filterProvidersExtraCost = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost/filter`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);

export const exportProvidersExtraCost = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/provider-extra-cost/export`, form,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then((data) => data);

//**************************************************************** //
//*************** proveedores documentales *********************** //
//**************************************************************** //

export const listarProveedoresDocumentales = async () => {

  let dataAux;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/listarProveedoresDocumentales`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const filtrarProveedoresDocumentales = async (filters) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/filtrarProveedoresDocumentales`,
    filters,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const guardarProveedoresDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/guardarProveedoresDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const editarProveedoresDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/editarProveedoresDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const duplicarProveedoresDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/duplicarProveedoresDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const eliminarProveedoresDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/eliminarProveedoresDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const downloadReporteProveedoresDocumentales = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/reporteProveedoresDocumentales`,
    filters,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
    let blob = new Blob([response.data], {
      type: ""
    });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.xlsx`;
    link.click();
  }).catch(error => {
    console.error("Error downloading report:", error);
  });
};

//**************************************************************** //
//****************** clientes documentales *********************** //
//**************************************************************** //

export const listarClientesDocumentales = async () => {

  let dataAux;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/listarClientesDocumentales`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const filtrarClientesDocumentales = async (filters) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/filtrarClientesDocumentales`,
    filters,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const buscarClientesDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/buscarClientesDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const guardarClientesDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/guardarClientesDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const editarClientesDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/editarClientesDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const eliminarClientesDocumentales = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/eliminarClientesDocumentales`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const downloadReporteClientesDocumentales = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/reporteClientesDocumentales`,
    filters,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
    let blob = new Blob([response.data], {
      type: ""
    });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.xlsx`;
    link.click();
  }).catch(error => {
    console.error("Error downloading report:", error);
  });
};


export const tariffClientsExtraCostoInit = () =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost/init`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsExtraCostoSearch = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost/search`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsExtraCostoStorage = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsExtraCostoIndex = () =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsExtraCostoFind = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost/find`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsExtraCostoUpdate = payload =>
  axios
  .put(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsExtraCostoDelete = payload =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        data: payload
      })
    .then(({ data }) => data);

export const tariffClientsExtraCostoFilter = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost/filter`, payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      })
      .then(({ data }) => data);

export const tariffClientsExtraCostoExport = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-extra-cost/export`, payload,
      {
          responseType: 'blob',
          headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
      })
      .then((data) => data);
//**************************************************************** //
//*************** proveedores terrestres *********************** //
//**************************************************************** //

export const listarProveedoresTerrestres = async () => {

  let dataAux;

  await axios.get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/listarProveedoresTerrestres`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const filtrarProveedoresTerrestres = async (filters) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/filtrarProveedoresTerrestres`,
    filters,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const guardarProveedoresTerrestres = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/guardarProveedoresTerrestres`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const editarProveedoresTerrestres = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/editarProveedoresTerrestres`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const duplicarProveedoresTerrestres = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/duplicarProveedoresTerrestres`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const eliminarProveedoresTerrestres = async (data) => {

  let dataAux;

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/eliminarProveedoresTerrestres`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(({ data }) => {
      dataAux = data;
    })
    .catch(error => {
      console.error(error);
    });

  return dataAux;
};

export const downloadReporteProveedoresTerrestres = async (filters, name) => {
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/reporteProveedoresTerrestres`,
    filters,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      responseType: "arraybuffer"
    }).then((response) => {
    let blob = new Blob([response.data], {
      type: ""
    });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.xlsx`;
    link.click();
  }).catch(error => {
    console.error("Error downloading report:", error);
  });
};

export const tariffClientsGroundIndex = () =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsGroundInit = () =>
  axios
  .get(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground/init`,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsSearch = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground/search`, payload ,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);


export const tariffClientsStorage = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground`, payload ,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsGroundFind = payload =>
  axios
  .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground/find`, payload ,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsGroundUpdate = payload =>
  axios
  .put(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground`, payload ,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => data);

export const tariffClientsGroundDelete = payload =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground` ,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        data: payload
      })
    .then(({ data }) => data);

export const tariffClientsGroundFilter = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground/filter` , payload ,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      })
    .then(({ data }) => data);

export const tariffClientsGroundExport = payload =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/administracionTarifas/client-ground/export`, payload,
      {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
      })
      .then((data) => data);


// **********************************************************************

export const listarLiquidacionesPreliminares = async (payload) => {

  let dataAux = [];
  
  const { type } = payload;
  type == 1 ? (store.state.serviciosLogisticos.loadingLiqClientes = true) : (store.state.serviciosLogisticos.loadingLiqProveedores = true);

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/extra-costs-liquidations/indexPreliminariesLiquidations`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => {

    dataAux = data;
    type == 1 ? store.state.serviciosLogisticos.loadingLiqClientes = false : store.state.serviciosLogisticos.loadingLiqProveedores = false;

  });

  return dataAux;

}

export const agregarActualizarLiquidacionesPreliminares = async (payload) => {

  let dataAux = {};
  
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/extra-costs-liquidations/createOrUpdatePreliminaryLiquidation`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => {
    dataAux = data;
  })
  .catch(error => {
    console.error(error);
  });

  return dataAux;

}

export const eliminarLiquidacionesPreliminares = async (payload) => {

  let dataAux = {};
  
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/extra-costs-liquidations/deletePreliminaryLiquidation`, payload,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then(({data}) => {
    dataAux = data;
  })
  .catch(error => {
    console.error(error);
  });

  return dataAux;

}



export const getPlantas = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/buscarPlantas/${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      })
    .then(({ data }) => data);